// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"456":"8bdf55a4","911":"9229615b"}[chunkId] + ".chunk.css";
};